import { Box, Typography } from '@mui/material';

import { useNavigate } from 'react-router-dom';

const EmptyState = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        width: '100%',
        minHeight: '1110px',

        justifyContent: 'flex-end',
        boxSizing: 'border-box',
      }}
    >
      <img
        alt="coinsEmptyState"
        src="/assets/background/coinsEmptyState.svg"
        style={{
          position: 'absolute',
          top: 50,
          left: 0,
          width: '760px',
          height: '941px',

          zIndex: 1,
        }}
      />
      <Typography
        sx={{ mt: '100px' }}
        zIndex={2}
        fontSize="48px"
        fontWeight="700"
        fontFamily={'AlmoniDL'}
        color="#343434"
      >
        ...נראה שטרם שלחת הוראת תשלום
      </Typography>
    </Box>
  );
};

export default EmptyState;
